import useDocumentTitle from '../hooks/useDocument';
import {Link} from 'react-router-dom';
import Header from '../components/header';
import Breadcrumb from '../components/breadcrumb';
import Features from '../components/features';
import CallToAction from '../components/calltoaction';
import WashPic from '../assets/img/washington.jpeg';
import floPic from '../assets/img/florence.jpeg';
import willPic from '../assets/img/will.jpeg';
import debPic from '../assets/img/claire.jpeg';
import Footer from '../components/footer';

function TeamView() {
  useDocumentTitle('Team-Quality-Home-Healthcare');
  return (
    <div className="body-wrapper">
      <Header />
      <Breadcrumb image={'bg-image-9'} title={'Our Team'} link={'Team'} />

      <div className="ltn__page-details-area ltn__service-details-area mb-105">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <h2 className="text-left compassion">Meet our team</h2>
              <div className="ltn__page-details-inner ltn__service-details-inner">
                <p className="values_p">
                  {' '}
                  <span className="ltn__first-letter">P</span>eople are at the
                  center of everything we do at Quality Health and Home Care
                  services.
                </p>
                <p className="values_p3">
                  We recruit team members who are not just compassionate and
                  committed to delivering high-quality care in the home but are
                  also passionate about improving the lives of others.
                </p>
                <p className="values_p3">
                  Our management team is continuously working hard to create and
                  maintain a team of workers who provide excellent personal and
                  complex homecare services. Our dedicated and experienced local
                  teams consistently deliver a high-quality, person-centered
                  service to individuals with life-limiting needs and
                  conditions.
                </p>
                <p className="values_p3">
                  We continuously do all that is within our means to help our
                  clients live the life they want and achieve all their
                  aspirations along the way. Most importantly, we help our
                  clients live as independently as possible in the comfort of
                  their own homes.
                </p>
                <p className="values_p3">
                  Quality health and Home Care services are what they are today
                  because of the hard work and dedication of our office and
                  frontline teams.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <aside className="sidebar-area ltn__right-sidebar">
                <h2 className="text-center compassion">Also see:</h2>
                <div className="widget-2 ltn__menu-widget ltn__menu-widget-2 text-uppercase">
                  <ul>
                    <li>
                      <Link to="/our-values">
                        Our values
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li className="">
                      <Link to="/how-we-deliver">
                        How we deliver our care
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/funding">
                        Funding your care
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>
      <div className="call-to-action-area call-to-action-5 bg-overlay-theme-90 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">
                  Washington Nharo Chief Executive Officer
                </h2>
                <p className="white-color">
                  Washington has a background working in education in the UK and
                  abroad. He also rose through the ranks in the health care
                  sector within a wide range of health and social care settings
                  over the last 20 years.  As founder and CEO of Quality Health
                  &Homecare Services Ltd, he is inspired by Christian values and
                  beliefs of being proactive, responsible, and law-abiding
                  citizens expressing Godly love, kindness, patience, and
                  concern for others, especially vulnerable people in our
                  communities.
                </p>
                <p className="white-color">
                  In founding Quality Health &Homecare Services Ltd, he wanted
                  to blend his wealthy experience in education, health and
                  social care, and Christian faith to create a
                  non-discriminatory, reflective, and dynamic complex health and
                  social care service delivering personalised, quality, and safe
                  care. Drawing on his multi-sectoral experience, has also
                  successfully been the Registered Manager for the organisation
                  for the past 10 years. He strives to build an informed and
                  diverse team with a broad and balanced worldview, capable of
                  providing holistic, comprehensive, individualized complex care
                  service that considers clients physical, mental, emotional,
                  and spiritual well-being.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-center">
                <img className="team-pics1" src={WashPic} alt="Mr Nharo" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="compassion">Florence Nharo Clinical Director</h2>
                <p className="">
                  Florence is a qualified Adult Nurse with many years’
                  experiences working in Critical Care, nursing patients with
                  complex health care needs. She has experience working in both
                  NHS and private hospitals in the West Midlands, East Midlands
                  and in Wales. Florence has also held several senior management
                  roles in Health and Social Care over the last 20 years.
                </p>
                <p>
                  In her role as our clinical Director, she is responsible for
                  providing clinical oversight over our clinical team comprising
                  of qualified nurses and carers providing care in the community
                  nursing to clients with complex care needs. Having co-founded
                  Quality together with Washington, she is out going, generous
                  and passionate about people and dedicated to ensuring we
                  consistently deliver a high-quality, personalised care service
                  that meets the needs of each of our clients.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-center">
                <img className="team-pics1" src={floPic} alt="Mrs Nharo" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 compassion-bg pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">William Mansell Care Manager</h2>
                <p className="white-color">
                  William has extensive knowledge of management within the Care
                  Sector having worked in the sector for 10 years. His previous
                  experience involves working as a coordinator for a national
                  Live in Care provider, as well as Quality Assurance Manager
                  for a local company before joining QHHCS in February of 2023.
                </p>
                <p className="white-color">
                  Prior to this William worked as a Catering Manager managing
                  both Kitchen and Housekeeping for a large 70 bedded Care Home
                  in Evesham as well as various other catering management roles.
                </p>
                <p className="white-color">
                  In his current role William enjoys the fact that every day is
                  different. When not in the office, he will be meeting new
                  perspective clients and their families, completing spot checks
                  and supervisions on the staff, or providing care to our
                  clients out in the community.
                </p>
                <p className="white-color">
                  He is born and bred in Evesham and knows the area very well.
                  He enjoys swimming and visiting his sisters and nephew as well
                  as walking his miniature dachshund, Ralph.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-center">
                <img className="team-pics1" src={willPic} alt="Mr Mansell" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="compassion">
                  Debbie Clarke Administrative Assistant
                </h2>
                <p className="">
                  Debbie has extensive care experience having worked about 15
                  years, predominantly in care home settings supporting a wide
                  variety of conditions and clients such as Huntington's
                  disease, dementia, learning disabilities, mental health,
                  Parkinson's.
                </p>
                <p>
                  In her current role she enjoys being able to use her previous
                  skills and experience in a new administrative role acting as a
                  personal assistant to the directors and care manager. Among
                  many things her role involves liaising with external multi
                  agencies making referrals for our clients, doing rotas, doing
                  manual handling and risk assessments. She lives in Pershore
                  with her teenage son and dog, Ruby. She also enjoys going for
                  walks, reading, and watching films.  
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-center">
                <img className="team-pics1" src={debPic} alt="Debbie Clarke" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Features
        icon1="fas fa-chevron-right"
        icon2="fas fa-volume-up"
        text1=" Combining skills, expertise and knowledge to offer quality
                  care."
        text2="Read what our customers have to say about us.
        "
        link1="/team"
        link2="/testimonials"
        btn1="Meet our team"
        btn2="Read our testimonials"
      />
      <CallToAction />
      <Footer />
    </div>
  );
}

export default TeamView;
